import { createMetaTracking } from './metaTrackingCore';
export const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID ?? '504997433914174';
let instance, memoryIntent = null;
// Round 9 forbids every advertising transport on the Webflow OAuth callback,
// even with prior consent and even though our frame cannot read portal auth data.
// Keep the document-level flag latched after the callback URL has been cleaned.
export function isMetaSuppressed(path) {
  if (typeof window === 'undefined') return true;
  return Boolean(window.__UB_NO_TELEMETRY__) ||
    (path || window.location.pathname).startsWith('/webflow-register');
}
export function getMetaTracking() {
  if (isMetaSuppressed()) return null;
  if (!instance) {
    instance = createMetaTracking({ window, pixelId: META_PIXEL_ID, surface: 'portal', frameUrl: 'https://ultimo-bots.com/meta-pixel-v2.html' });
  }
  return instance;
}
export function trackRegistration(userId, channel) {
  if (userId) getMetaTracking()?.track('CompleteRegistration', { content_category: channel }, `registration:${userId}`);
}

const CHECKOUT_KEY = 'ub_meta_checkout';
export function beginWixCheckout(botId) {
  try {
    const tracker = getMetaTracking();
    if (!botId || !tracker?.enabled || new URLSearchParams(window.location.search).has('demo')) return;
    const intent = { botId: String(botId), startedAt: Date.now() };
    memoryIntent = intent;
    try { window.sessionStorage.setItem(CHECKOUT_KEY, JSON.stringify(intent)); } catch { /* blocked iframe storage: retain intent in memory */ }
    tracker.track('InitiateCheckout', { content_category: 'wix' }, `checkout:${botId}:${Math.floor(intent.startedAt / 60000)}`);
    window.dispatchEvent(new Event('ub-meta-checkout'));
  } catch { /* checkout never depends on measurement */ }
}
export function pendingWixCheckout() {
  try {
    if (!getMetaTracking()?.enabled) return null;
    let intent = memoryIntent;
    try { intent = JSON.parse(window.sessionStorage.getItem(CHECKOUT_KEY) || 'null') || memoryIntent; } catch { /* memory fallback */ }
    if (intent && typeof intent.botId === 'string' && Number.isFinite(intent.startedAt) && intent.startedAt <= Date.now() && Date.now() - intent.startedAt < 86400000) return intent;
  } catch { /* optional storage */ }
  return null;
}
// Backend status is authoritative. A paid plan, registration or button click is NOT a trial.
export function confirmedWixTrial(bot, intent, now = Date.now()) {
  const sub = bot?.subscription;
  const createdAt = Date.parse(sub?.created_at);
  return Boolean(intent && Number.isFinite(intent.startedAt) && intent.startedAt <= now &&
    String(bot?.id) === intent.botId && sub?.id && sub?.wix_subscription_id &&
    bot?.status_display?.className === 'trialing' && typeof bot?.subscription_plan?.name === 'string' && bot.subscription_plan.name !== 'Free' &&
    ['active', 'trialing'].includes(sub.status) && !sub.cancel_at_period_end &&
    Number.isFinite(createdAt) && createdAt >= intent.startedAt - 60000 && createdAt <= now &&
    now - intent.startedAt < 86400000);
}
export function observeWixTrial(bot) {
  try {
    const intent = pendingWixCheckout();
    if (!confirmedWixTrial(bot, intent)) return false;
    const sent = getMetaTracking()?.track('StartTrial', { content_category: 'wix' }, `wix-trial:${bot.subscription.id}`);
    // The conversion is now in the durable outbox; no more billing polling.
    if (sent) {
      memoryIntent = null;
      try { window.sessionStorage.removeItem(CHECKOUT_KEY); } catch { /* optional storage */ }
    }
    return sent;
  } catch { return false; }
}
